export default __webpack_public_path__ + "static/media/GR00041-class_illustration.b9228e63.svg";